import isString from "lodash/isString";
import map from "lodash/map";
export const updateGroupTable = (wrapper, data) => {
    var _a, _b;
    if (!wrapper || !((_a = wrapper["data-grid"]) === null || _a === void 0 ? void 0 : _a.current))
        return;
    const groupRef = (_b = wrapper["data-grid"]) === null || _b === void 0 ? void 0 : _b.current;
    (groupRef === null || groupRef === void 0 ? void 0 : groupRef.setData) && groupRef.setData(map(data, e => ({ ...e, Id: e.NodeId })));
};
export const updateGroupLabelTable = (groupLabel, data) => {
    const groupTableWrapper = groupLabel.tag && isString(groupLabel.tag)
        ? document.querySelector(`#${groupLabel.tag}`)
        : null;
    groupTableWrapper && updateGroupTable(groupTableWrapper, data);
};
export const updateGroupNodeTable = (groupNode, data) => {
    var _a;
    if (((_a = groupNode === null || groupNode === void 0 ? void 0 : groupNode.labels) === null || _a === void 0 ? void 0 : _a.size) === 1) {
        updateGroupLabelTable(groupNode.labels.first(), data);
    }
};
